import React, { useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerIconRetina from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIconRetina,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

type Props = {
  propLocation: [number, number];
};

const MapComponent: React.FC<Props> = ({ propLocation }) => {
  const mapRef = useRef<L.Map | null>(null);

  const customIcon = L.divIcon({
    className: "custom-marker",
    html: `<div style="background-color: red; border-radius: 50%; width: 24px; height: 24px; border: 2px solid #fff;"></div>`,
    iconSize: [25, 25],
    iconAnchor: [12, 24],
  });

  useEffect(() => {
    if (mapRef.current && propLocation) {
      mapRef.current.setView(propLocation, mapRef.current.getZoom());
    }
  }, [propLocation]);

  const MapUpdater = () => {
    const map = useMap();
    useEffect(() => {
      if (propLocation) {
        map.setView(propLocation, map.getZoom());
      }
    }, [propLocation, map]);
    return null;
  };

  return (
    <MapContainer
      center={propLocation}
      zoom={20}
      style={{ height: "400px", width: "100%" }}
      // whenReady={(_: any, target: any) => {
      //   mapRef.current = target;
      // }}
    >
      {propLocation[0] !== 0 && propLocation[1] !== 0 ? (
        <>
          <TileLayer
            url={`https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&hl=th&gl=TH&${process.env.REACT_APP_API_KEY_GOOGLE}`}
            attribution={"-"}
            subdomains={["mt0", "mt1", "mt2", "mt3"]}
          />
          <>
            <Marker position={propLocation} icon={customIcon}>
              <Popup>Your current location.</Popup>
            </Marker>
            <MapUpdater />
          </>
        </>
      ) : null}
    </MapContainer>
  );
};

export default MapComponent;
